import style from "./default.module.scss";
// import MobHeader from "../../components/header/header"

export function DefaultLayout({children}) {
    return (
        <div >
            {/*<MobHeader />*/}
            <div className={style.row}>
                {children}
            </div>
        </div>
    );
}
